import { ActionType } from '../infrastructure/actionTypes';
import { IUserDownloadList } from '../infrastructure/interfaces';

export default (list: IUserDownloadList[] = [], action: any) => {
  switch (action.type) {
    case ActionType.START_LOADING_PDF:
    case ActionType.START_LOADING_DIV_COST_CSV:
    case ActionType.START_LOADING_PRODUCT_ANALYTICS_CSV:
    case ActionType.START_LOADING_ZIP:
      return [...list, { name: action.name, status: 1, id: action.id, documentType: action.documentType }];
    case ActionType.FINISH_LOADING_PDF:
    case ActionType.FINISH_LOADING_CSV:
    case ActionType.FINISH_LOADING_ZIP:
      const newList = [...list];
      newList.forEach((el) => {
        if (el.id === action.id) {
          el.status = 2;
        }
      });
      return newList;
    case ActionType.DELETE_PDF_FROM_DOWNLOAD:
    case ActionType.DELETE_CSV_FROM_DOWNLOAD:
    case ActionType.DELETE_ZIP_FROM_DOWNLOAD:
      return list.filter(el => el.id !== action.id);
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/userDownloadList.ts